<template>
    <div class="p-6 mb-8 bg-white rounded-lg lg:p-8">
        <p class="mb-6 text-xl font-bold text-primary-500">V. Past Surgical History 過去の手術歴</p>
        
        <p class="mb-5 text-darkgray-800">Please indicate the date of your last visit to a hospital, clinic, or diagnostic center, including the reason, hospitalization status, and any findings or diagnoses. / 病院、クリニック、健診センターへの最近の受診日、受診理由、入院の有無、および診断結果(必要に応じて)を明記してください。</p>
        
        <div 
            class="grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-4 bg-primary-50 rounded-2xl p-5 lg:p-7 mb-2" 
            v-for="(surgery, index) in item" :key="index"
        >
            <div v-if="index >= 1" class="col-span-full text-right">
                <small v-if="!disableInputs" @click="remove(index)" class="text-red-500 cursor-pointer text-sm">Remove</small>
            </div>
            
            <div class="col-span-full lg:col-span-4">
                <CalendarPicker 
                    :disabled="disableInputs"
                    :key="surgery.date"
                    v-model="surgery.date"
                    :id="`surgery-date-${index}`"
                    :inline="false"
                    placeholder="Date 日付"
                    isTodayMaxDate
                    :error="errors[`past_surgical_history.${index}.date`] ? errors[`past_surgical_history.${index}.date`][0] : ''"
                    />
                </div>
            
            <div class="col-span-full lg:col-span-4">
                <text-input
                    v-model="surgery.purpose_of_visit"
                    :id="`purpose-${index}`"
                    type="text"
                    placeholder="Purpose of Visit 受診目的"
                    :disabled="disableInputs"
                    :error="errors[`past_surgical_history.${index}.purpose_of_visit`] ? errors[`past_surgical_history.${index}.purpose_of_visit`][0] : ''"
                    
                />
            </div>
            
            <div class="col-span-full lg:col-span-4">
                <text-input
                    v-model="surgery.findings"
                    :id="`findings-${index}`"
                    type="text"
                    placeholder="Findings (if necessary) 診断結果(必要に応じて)"
                    :disabled="disableInputs"
                    :error="errors[`past_surgical_history.${index}.findings`] ? errors[`past_surgical_history.${index}.findings`][0] : ''"
                />
            </div>
        </div>
        
        <p v-if="!disableInputs" @click="addRow" class="font-bold text-primary-500 hover:text-primary-700 transition cursor-pointer text-sm w-fit">
            Add another +
        </p>
    </div>
</template>

<script setup lang="ts">
import TextInput from '@/components/inputs/TextInput.vue';
import CalendarPicker from '@/components/CalendarPicker.vue';
import { ref } from 'vue';

const props = defineProps({
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: false
    },
    errors: {
        type: Array,
        required: true
    },
})

const item = ref(props.form)

const addRow = () => {
    item.value.push({
        date: null,
        purpose_of_visit: null,
        findings: null,
    })
}

const remove = (index: string) => {
    item.value.splice(index, 1);
}
</script>